import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/baa`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });
const adminAuth = (t) => ({ headers: { Authorization: `Bearer ${t}` } });

export const baaApi = {
  document: () => axios.get(`${API}/document`).then((r) => r.data),
  status: () => axios.get(`${API}/status`, auth()).then((r) => r.data),
  sign: (body) => axios.post(`${API}/sign`, body, auth()).then((r) => r.data),
  adminSettings: (t) => axios.get(`${API}/admin/settings`, adminAuth(t)).then((r) => r.data),
  adminSaveSettings: (t, body) => axios.put(`${API}/admin/settings`, body, adminAuth(t)).then((r) => r.data),
  adminAgreements: (t) => axios.get(`${API}/admin/agreements`, adminAuth(t)).then((r) => r.data),
  adminAgreement: (t, id) => axios.get(`${API}/admin/agreements/${id}`, adminAuth(t)).then((r) => r.data),
};

export const BAA_EVENT = 'practcom:baa-required';
export const BAA_SIGNED_EVENT = 'practcom:baa-signed';
export const openBaa = () => window.dispatchEvent(new Event(BAA_EVENT));

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${(x.loc || []).slice(-1)[0]}: ${x.msg}`).join(' · ');
  return d || e?.message || 'Something went wrong';
};

export const formatSignedAt = (iso) =>
  new Date(iso).toLocaleString('en-US', { timeZone: 'America/New_York', dateStyle: 'long', timeStyle: 'short' }) + ' ET';
